import { Star } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export default function Testimonials({ limit }) {
  const items = limit ? TESTIMONIALS.slice(0, limit) : TESTIMONIALS;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-testid="testimonials-grid">
      {items.map((t, i) => (
        <article key={i} className="border-t border-[#E5E3DB] pt-8" data-testid={`testimonial-${i}`}>
          <div className="flex gap-0.5" aria-label={`${t.rating} of 5 stars`}>
            {Array.from({ length: t.rating }).map((_, j) => (
              <Star key={j} size={14} fill="#C5A059" stroke="#C5A059" />
            ))}
          </div>
          <blockquote className="font-display text-2xl md:text-3xl leading-snug mt-5 text-[#0B1426]">
            “{t.text}”
          </blockquote>
          <div className="mt-6 text-sm text-[#4F5B6A]">
            <span className="font-medium text-[#0B1426]">{t.name}</span> · {t.suburb}
          </div>
        </article>
      ))}
    </div>
  );
}
